export default __webpack_public_path__ + "assets/images/ecba5a6d82222f5aaa15a8e31d0580f1.jpg";